export default "__VITE_ASSET__BIA4JTBD__"